import styled from 'styled-components';

export const ExpiredLink = styled.main`
	display: flex;
	width: 100%;
	flex-direction: column;
	height: 100vh;
`;
